<template>
  <div class="p-2" style="display: flex; flex-direction: row; border: 1px solid #e2e8f0; border-radius: 5px;">
    <div style="width: 108px;" class="px-0">
      <b-img v-if="!loading" :src="imageURL || defaults.imageURL" alt="Image" class="rounded align-items-center" style="object-fit: cover; width: 108px; height: 72px;"/>
      <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height: 100px;">
        <b-spinner type="grow" variant="primary" />
      </div>
    </div>
    <div style="width: 100%;" class="px-1 pl-2 pt-1">
      <div style="display: -webkit-box; line-clamp: 2; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;"><strong>{{ title || defaults.title
          }}</strong></div>
      <div><a :href="url" target="_blank" class="text-muted">{{ domain }}</a></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '-',
    },
    url: {
      type: String,
      default: 'https://example-real-links.io/',
    },
    imageURL: {
      type: String,
      default: 'https://placehold.co/108x72',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    defaults() {
      return {
        title: '-',
        url: 'https://example-real-links.io/',
        imageURL: 'https://placehold.co/108x72',
      };
    },
    domain() {
      try {
        return new URL(this.url || this.defaults.url).hostname;
      } catch (e) {
        return '-';
      }
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/content-share/content-share-editor/ContentShareLink.vue